export default __webpack_public_path__ + "static/media/whatsapp.f228286c.svg";